/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.io = {};
    Blockly.Blocks.io.style = 'io_blocks';

    /**
     * ***************************************************************************
     * IO_PINMODE block definition
     * ***************************************************************************
     */
    Blockly.Blocks.io_pinmode = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.IO_PINMODE)
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME), "VAR")
                .appendField(Blockly.Msg.IO_PINMODE_AS).appendField(new Blockly.FieldDropdown([
                    ["OUTPUT", "OUTPUT"],
                    ["INPUT", "INPUT"],
                    ["INPUT_PULLUP", "INPUT_PULLUP"]
                ]),
                "MODE");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * ***************************************************************************
     * IO_DIGITAL_WRITE block definition
     * ***************************************************************************
     */
    Blockly.Blocks.io_digital_write = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.IO_DIGITAL_WRITE)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN")
                .appendField(new Blockly.FieldDropdown(profile["default"].logic_levels), "STAT");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    Blockly.Blocks.io_digital_write_var = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.setStyle(Blockly.Blocks.io.style);
            this.appendValueInput("PIN", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.IO_DIGITAL_WRITE)
            this.appendValueInput("STAT", "Boolean").setCheck("Boolean").setAlign(Blockly.ALIGN_RIGHT).appendField("");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0,
                null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * ***************************************************************************
     * IO_DIGITAL_READ block definition
     * ***************************************************************************
     */
    Blockly.Blocks.io_digital_read = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.IO_DIGITAL_READ)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN");
            this.setOutput(!0, "Boolean")
        }
    };
    Blockly.Blocks.io_digital_read_pin = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput("").appendField(Blockly.Msg.IO_DIGITAL_READ);
            this.appendValueInput("PIN", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(true);
            this.setOutput(true, "Boolean")
        }
    };
    Blockly.Blocks.io_analog_write = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput().appendField(Blockly.Msg.IO_ANALOG_WRITE).appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN");
            this.appendValueInput("NUM", "Number").appendField(Blockly.Msg.IO_VALUE).setCheck("Number");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
        }
    };
    Blockly.Blocks.io_analog_write_pin = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput().appendField(Blockly.Msg.IO_ANALOG_WRITE);
            this.appendValueInput("PIN", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT);
            this.appendValueInput("NUM", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.IO_VALUE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
        }
    };
    Blockly.Blocks.io_analog_read = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.IO_ANALOG_READ)
                .appendField(new Blockly.FieldDropdown(profile["default"].analog), "PIN");
            this.setOutput(!0, "Number");
        }
    };
    Blockly.Blocks.io_analog_read_pin = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput().appendField(Blockly.Msg.IO_ANALOG_READ);
            this.appendValueInput("PIN", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("A");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number");
        }
    };
    Blockly.Blocks.io_capacitive_read = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput().appendField(Blockly.Msg.IO_CAPACITIVE_READ).appendField(new Blockly.FieldDropdown(profile["default"].capacitive), "PIN");
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.io_pulsein = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput().appendField(Blockly.Msg.IO_PULSEIN).appendField(Blockly.Msg.IO_PIN).appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN").appendField(new Blockly.FieldDropdown(profile["default"].logic_levels), "STAT");
            this.appendValueInput("TIMEOUT", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.IO_PULSEIN_TIMEOUT);
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.io_interrupt = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.appendDummyInput().appendField(Blockly.Msg.IO_INTERRUPT)
                .appendField(Blockly.Msg.IO_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].intPins), "PIN")
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.IO_INT_RISING, "RISING"],
                    [Blockly.Msg.IO_INT_FALLING, "FALLING"],
                    [Blockly.Msg.IO_INT_CHANGE, "CHANGE"],
                    [Blockly.Msg.IO_INT_LOW, "LOW"]
            ]), "MODE");
            this.appendStatementInput("DO");
            this.setInputsInline(!1);
            this.setPreviousStatement(!1);
            this.setNextStatement(!1)
        }
    };
    Blockly.Blocks.io_digital_write_i2c = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.setTooltip("PCF8574 - I2C");
            this.appendDummyInput().appendField(Blockly.Msg.IO_DIGITAL_WRITE + " - I2C").appendField(new Blockly.FieldDropdown([
                ["0x20", "0x20"],
                ["0x21", "0x21"],
                ["0x22", "0x22"],
                ["0x23", "0x23"],
                ["0x24", "0x24"],
                ["0x25", "0x25"],
                ["0x26", "0x26"],
                ["0x27", "0x27"],
                ["0x38", "0x38"],
                ["0x39", "0x39"],
                ["0x40", "0x40"],
                ["0x41", "0x41"],
                ["0x42", "0x42"],
                ["0x43", "0x44"],
                ["0x45", "0x46"],
                ["0x47", "0x47"]
            ]), "ADDR").appendField(Blockly.Msg.IO_PIN).appendField(new Blockly.FieldDropdown([
                ["0", "0"],
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"],
                ["5", "5"],
                ["6", "6"],
                ["7", "7"]
            ]), "PIN")
            .appendField(new Blockly.FieldDropdown(profile["default"].logic_levels), "STAT");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.io_digital_write2_i2c = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.io.style);
            this.setTooltip("PCF8574 - I2C");
            this.appendDummyInput().appendField(Blockly.Msg.IO_DIGITAL_WRITE + " - I2C").appendField(new Blockly.FieldDropdown([
                ["0x20", "0x20"],
                ["0x21", "0x21"],
                ["0x22", "0x22"],
                ["0x23", "0x23"],
                ["0x24", "0x24"],
                ["0x25", "0x25"],
                ["0x26", "0x26"],
                ["0x27", "0x27"],
                ["0x38", "0x38"],
                ["0x39", "0x39"],
                ["0x40", "0x40"],
                ["0x41", "0x41"],
                ["0x42", "0x42"],
                ["0x43", "0x44"],
                ["0x45", "0x46"],
                ["0x47", "0x47"]
            ]), "ADDR");
            this.appendValueInput("PIN", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.IO_PIN);
            this.appendValueInput("STAT", "Boolean").setCheck("Boolean").setAlign(Blockly.ALIGN_RIGHT).appendField("");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
}
